import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-user-special-permission',
    templateUrl: './user-special-permission.component.html',
    styleUrls: ['./user-special-permission.component.scss'],
    standalone: false
})
export class UserSpecialPermissionComponent {
  
}
